// extracted by mini-css-extract-plugin
export default {"filtersBox":"_zK_gnMWrWUB2SU2G63r","checkbox":"RCH0C_K0whvghhjahZrg","inputBox":"zh6OqZhcOWiIeIDfpb_N","submitBtn":"lPXbR6Qw8Ke9ezJCiqSa"};